/**
 * Handles the JavaScript associated with sidebar components
 */

class Sidebar {
	constructor() {

		const timer = document.querySelector( '.sidebar-component-countdown-clock' );
		const jsTimerHook = document.getElementById( 'js-timer' );
		const jsMsgHook = document.getElementById( 'js-static-countdown-message' );

		if ( timer ) {
			var endtime = jsTimerHook.getAttribute( 'data-endtime' );

			// Run the function once to avoid a delayed start
			updateClock( endtime );

			// Set up the time interval to tick the clock down
			var timeinterval = setInterval( function () {

				updateClock( endtime );

			}, 1000 );

		} // timer

		// Calculate the remaining time
		function getTimeRemaining( endtime ) {

			// Eastern Time Offset
			var offset = -5.0
			var clientDate = new Date();
			var utc = clientDate.getTime() + ( clientDate.getTimezoneOffset() * 60000 );
			var current = new Date( utc + ( 3600000 * offset ) );

			var t = Date.parse( endtime ) - Date.parse( current );
			var seconds = Math.floor( ( t / 1000 ) % 60 );
			var minutes = Math.floor( ( t / 1000 / 60 ) % 60 );
			var hours = Math.floor( ( t / ( 1000 * 60 * 60 ) ) % 24 );
			var days = Math.floor( t /( 1000 * 60 * 60 * 24 ) );

			// Build out the JSON object
			return {
				'total': t,
				'days': days,
				'hours': hours,
				'minutes': minutes,
				'seconds': seconds
			};

		} // getTimeRemaining()

		// Update the DOM with the new time
		function updateClock( endtime ) {

			var expirationAction = jsTimerHook.getAttribute( 'data-expiration' );
			var t = getTimeRemaining( endtime );
			var days = document.getElementById( 'timer-days' );
			var hours = document.getElementById( 'timer-hours' );
			var minutes = document.getElementById( 'timer-minutes' );
			var seconds = document.getElementById( 'timer-seconds' );

			days.querySelector('.sidebar-timer__value').innerHTML = ( '0' + t.days ).slice( -2 );
			hours.querySelector('.sidebar-timer__value').innerHTML = ( '0' + t.hours ).slice( -2 );
			minutes.querySelector('.sidebar-timer__value').innerHTML = ( '0' + t.minutes ).slice( -2 );

			// Adds a leading 0 to maintain spacing
			seconds.querySelector('.sidebar-timer__value').innerHTML = ( '0' + t.seconds ).slice( -2 );

			if ( t.total <= 0 ) {

				// Stop the timer
				clearInterval( timeinterval );

				// This likely won't display in the UI, but let's set it anyway.
				days.querySelector('.sidebar-timer__value').innerHTML = 0;
				hours.querySelector('.sidebar-timer__value').innerHTML = 0;
				minutes.querySelector('.sidebar-timer__value').innerHTML = 0;
				seconds.querySelector('.sidebar-timer__value').innerHTML = 0;

				// The timer has expired, so hide it
				jsTimerHook.classList.add( 'is-removed' );
				jsTimerHook.classList.remove( 'is-active' );

				// If we should be displaying the message upon expiration, do so now
				if( expirationAction ===  'display-message' ) {

					jsMsgHook.classList.remove( 'is-removed' );
					jsMsgHook.classList.remove( 'is-active' );

				} else if ( expirationAction ===  'hide-component' ) {

					timer.classList.add( 'is-removed' );

				}

			}

		} // updateClock()

	} // constructor()

} // Sidebar {}

export default Sidebar;



// WEBPACK FOOTER //
// ./assets/components/sidebar/sidebar.js